import {
    STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            saveFastStockLoadingDataPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveDataSucces: null,
                saveDataError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            saveFastStockLoadingDataPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveData: action.data,
                saveDataSucces: true,
                saveDataError: null,
                savedForm: true
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            saveFastStockLoadingDataPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveDataSucces: false,
                saveDataError: action.data.error,
                savedForm: false
            }
          }
        }
      default:
        return state
    }
  }